import InfiniteLoader from "./InfiniteLoader";
export default InfiniteLoader;
export { InfiniteLoader };